import { compose, map, prop, propEq, either } from 'ramda'

export const ACTIONS = [
  { name: 'Criação de usuários', id: 'insert_user', entity: 'user' },
  { name: 'Remoção de usuários', id: 'remove_user', entity: 'user' },

  { name: 'Atualizar de atividades', id: 'upsert_service_order', entity: 'service_order' },
  { name: 'Criar de atividades', id: 'insert_service_order', entity: 'service_order' },

  { name: 'Todas', id: 'all', entity: 'all' }
]

export const getActionsForEntity = entity => ACTIONS.filter(either(propEq('entity', entity), propEq('entity', 'all')))

export const getActionValues = entity => compose(map(prop('id')), getActionsForEntity)(entity)
